import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_66: FaireProductEntity = {
  token: "catalog_prod_prod-66",
  type: "product",
  name: "Wool Throw Blanket - Herringbone - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 62.81,
  msrpDollars: 157.03,
  sku: "JA0066",
  caseSize: 6,
  material: "Metal",
  collectionToken: "col_japandi",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 381,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_party-supplies"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
